"use client";

import { Faq4Section } from "./faqs4/Faq4Section";

const Faqs4 = (props: Parameters<typeof Faq4Section>[0]) => <Faq4Section {...props} />;

export default Faqs4;
